<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="orderId"
      :col="3"
      :columns="getColumns()"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :requestPromise="loadDataList"
    >
      <template v-slot:orderNo="{ text }">
        <ellipsis :length="30" tooltip>{{ text }}</ellipsis>
      </template>
      <template v-slot:orderSamsNo="{ text }">
        <ellipsis :length="50" tooltip>{{ text }}</ellipsis>
      </template>
      <template v-slot:orderProName="{ text }">
        <ellipsis :length="50" tooltip>{{ text }}</ellipsis>
      </template>
      <template v-slot:orderEticketUrl="{ text }">
        <a v-if="text" :href="text" target="_blank" rel="noopener noreferrer">查看电子票</a>
        <span v-else>-</span>
      </template>
    </StandardSearchPageView>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'OrderRecordsComponent',
  components: {
    StandardSearchPageView
  },
  data () {
    return {
      queryParams: {},
      searchOptions: [
        {
          name: '订单编号',
          key: 'orderNo',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '商品信息',
          key: 'orderProName',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '山姆订单号',
          key: 'samsNo',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '码信息',
          key: 'redeemCode',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '下单日期',
          key: 'createTimeStart,createTimeEnd',
          type: 'rangePicker'
        }
      ]
    }
  },
  methods: {
    loadDataList (params) {
      const requestParams = {
        pageNum: params.pageNum || (params.limitDto && params.limitDto.pageNum) || 1,
        pageSize: params.pageSize || (params.limitDto && params.limitDto.pageSize) || 10,
        orderNo: params.orderNo || '',
        orderProName: params.orderProName || '',
        samsNo: params.samsNo || '',
        redeemCode: params.redeemCode || '',
        createTimeStart: params.createTimeStart || '',
        createTimeEnd: params.createTimeEnd || ''
      }
      return this.getHttpServices().getSourceService().post('/sams/order/list', requestParams)
    },
    getColumns () {
      return [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '220px',
          scopedSlots: { customRender: 'orderNo' }
        },
        {
          title: '山姆订单号',
          dataIndex: 'orderSamsNo',
          width: '220px',
          scopedSlots: { customRender: 'orderSamsNo' }
        },
        {
          title: '会员卡号',
          dataIndex: 'orderSamsMemberNo',
          width: '220px'
        },
        {
          title: '商品信息',
          dataIndex: 'orderProName',
          width: '280px',
          scopedSlots: { customRender: 'orderProName' }
        },
        {
          title: '关联套餐/房型',
          dataIndex: 'orderOptionName',
          width: '140px'
        },
        {
          title: '预约码/核销码',
          dataIndex: 'orderRedeemCode',
          width: '140px'
        },
        {
          title: '码状态',
          dataIndex: 'orderCodeStatusName',
          width: '120px'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          width: '120px'
        },
        {
          title: '电子票链接',
          dataIndex: 'orderEticketUrl',
          width: '200px',
          scopedSlots: { customRender: 'orderEticketUrl' }
        },
        {
          title: '姓名',
          dataIndex: 'orderCustomerName',
          width: '120px'
        },
        {
          title: '手机号',
          dataIndex: 'orderCustomerMobile',
          width: '140px'
        },
        {
          title: '邮箱',
          dataIndex: 'orderCustomerEmail',
          width: '180px',
          ellipsis: true
        },
        {
          title: '下单时间',
          dataIndex: 'orderCreateTime',
          width: '180px',
          customRender: (text) => {
            return text ? this.getDateHelper().formatDate(text, 'YYYY-MM-DD HH:mm:ss') : ''
          }
        }
      ]
    }
  }
}
</script>

<style scoped></style>
<!-- <style scoped lang="less">
::v-deep .ant-table-tbody > tr > td {
  word-break: keep-all;
}
</style> -->
